<template>
  <Tab
    :list="tab.list"
    :current="tab.current"
    class="-mypage"
    @click-tab="clickTab"
  />

  <HeadingLv1 text="病院見学申込み一覧" />
  <div class="u-containar">
    <MypageContents>
      <TabSeminar
        :list="tabSeminar"
        :current="state.currentTabSeminar"
        @click-tab="clickTabSeminar"
        class="s_tab"
      />
      <Loader v-if="loading" />

      <div v-if="state.currentTabSeminar === 0">
        <template v-if="!loading">
          <HospitalCassetteSimple
            v-if="items.length > 0"
            :items="items"
            :page="$route.path.split('/')[2]"
          />
          <NothingArea
            v-if="items.length === 0"
            :label="'見学申込み'"
            :items="items_reco"
          />
          <BackTo :link="'/mypage'" />
        </template>
      </div>

      <div v-if="state.currentTabSeminar === 1">
        <template v-if="!loading">
          <HospitalCassetteSimple
            v-if="items_s.length > 0"
            :items="items_s"
            :page="$route.path.split('/')[2]"
            isSeminar
          />
          <Alert
            v-if="items_s.length === 0"
            text="見学申込みしている病院はありません"
          />
          <BackTo :link="'/mypage'" />
        </template>
      </div>
    </MypageContents>
  </div>
</template>

<script lang="ts">
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { computed, reactive, defineComponent } from 'vue'
import { useRouter } from 'vue-router'
import Alert from '@/components/elements/Alert.vue'
import Tab from '@/components/elements/Tab.vue'
import HeadingLv1 from '@/components/elements/HeadingLv1.vue'
import MypageContents from '@/components/block/MypageContents.vue'
import TabSeminar from '@/components/elements/TabSeminar.vue'
import HospitalCassetteSimple from '@/components/block/HospitalCassetteSimple.vue'
import NothingArea from '@/components/block/NothingArea.vue'
import BackTo from '@/components/block/BackTo.vue'
import { mypageTabItems } from '@/utils/commonDataset'
import Loader from '@/components/elements/Loader.vue'

export default defineComponent({
  name: 'mypageVisitApplicationList',

  props: {
    items: {
      type: Object,
      default: () => ({})
    },
    items_s: {
      type: Object,
      default: () => ({})
    },
    items_reco: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: true
    }
  },

  components: {
    Alert,
    Tab,
    HeadingLv1,
    MypageContents,
    TabSeminar,
    HospitalCassetteSimple,
    NothingArea,
    BackTo,
    Loader
  },

  setup() {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()

    const tab = reactive({
      list: mypageTabItems,
      current: 1
    })

    const clickTab = (i: number) => {
      router.push({ path: tab.list[i].link })
    }

    const tabSeminar = computed(() => {
      return [
        {
          label: '病院・初期研修',
          name: 'first'
        },
        {
          label: '専門研修',
          name: 'second'
        }
      ]
    })

    const judgeCurrentTabSeminar = () => {
      const index = Number(route.query.tab)
      if (index) {
        return index > 0 ? index : 0
      }
      return store.state.userInfo.member_type === '医学生' ? 0 : 1
    }

    const state = reactive<any>({
      currentTabSeminar: judgeCurrentTabSeminar()
    })

    const clickTabSeminar = (i: number) => {
      state.currentTabSeminar = i
    }

    return {
      tab,
      clickTab,
      tabSeminar,
      state,
      clickTabSeminar,
      judgeCurrentTabSeminar
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.s_tab {
  margin-bottom: 30px;
  @include mixins.media() {
    margin-bottom: 24px;
  }
}
</style>
